/* JNGLSLNG theme behaviour — vanilla JS, no framework. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- mobile menu ---- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-menu-open]');
    var close = e.target.closest('[data-menu-close]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!menu) return;
    if (open) menu.setAttribute('data-open', 'true');
    if (close) menu.setAttribute('data-open', 'false');
  });

  /* ---- scroll reveal ---- */
  var reveals = document.querySelectorAll('.reveal');
  if (reduce || !('IntersectionObserver' in window)) {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  }

  /* ---- showroom rotator ---- */
  document.querySelectorAll('[data-showroom]').forEach(function (root) {
    var frames = Array.prototype.slice.call(root.querySelectorAll('[data-showroom-frame]'));
    if (!frames.length) return;
    var titleEl = root.querySelector('[data-showroom-title]');
    var linkEl = root.querySelector('[data-showroom-link]');
    var indexEl = root.querySelector('[data-showroom-index]');
    var configEl = root.querySelector('[data-showroom-config]');
    var current = 0;
    var interval = parseInt(root.getAttribute('data-interval') || '5000', 10);

    function render() {
      frames.forEach(function (f, i) { f.classList.toggle('is-active', i === current); });
      var active = frames[current];
      if (titleEl) titleEl.textContent = active.getAttribute('data-title') || '';
      if (linkEl) linkEl.setAttribute('href', active.getAttribute('data-url') || '#');
      if (indexEl) indexEl.textContent = ('0' + (current + 1)).slice(-2);
      if (configEl) configEl.textContent = active.getAttribute('data-variants') || '0';
    }
    function step(dir) { current = (current + dir + frames.length) % frames.length; render(); }

    root.querySelectorAll('[data-showroom-prev]').forEach(function (b) { b.addEventListener('click', function () { step(-1); }); });
    root.querySelectorAll('[data-showroom-next]').forEach(function (b) { b.addEventListener('click', function () { step(1); }); });
    render();
    if (!reduce && frames.length > 1) setInterval(function () { step(1); }, interval);
  });

  /* ---- product image sequence ---- */
  document.querySelectorAll('[data-viewer]').forEach(function (root) {
    var frames = Array.prototype.slice.call(root.querySelectorAll('.product-viewer__frame'));
    var counter = root.querySelector('[data-viewer-count]');
    var current = 0;
    function render() {
      frames.forEach(function (f, i) { f.classList.toggle('is-active', i === current); });
      if (counter) counter.textContent = ('0' + (current + 1)).slice(-2);
    }
    root.querySelectorAll('[data-viewer-prev]').forEach(function (b) { b.addEventListener('click', function () { current = (current - 1 + frames.length) % frames.length; render(); }); });
    root.querySelectorAll('[data-viewer-next]').forEach(function (b) { b.addEventListener('click', function () { current = (current + 1) % frames.length; render(); }); });
    render();
  });

  /* ---- variant picker (Shopify native form) ---- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (root) {
    var variants;
    try { variants = JSON.parse(root.querySelector('[data-variant-json]').textContent); } catch (e) { return; }
    var idInput = root.querySelector('[data-variant-id]');
    var submit = root.querySelector('[data-add-button]');
    var priceEl = root.querySelector('[data-variant-price]');
    var money = root.getAttribute('data-money-format') || '${{amount}}';

    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      return money.replace(/\{\{\s*amount\s*\}\}/, value)
                  .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
                  .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
    }
    function selected() {
      var chosen = Array.prototype.map.call(root.querySelectorAll('[data-option-index]'), function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      if (!chosen.length) return variants[0];
      return variants.filter(function (v) {
        return chosen.every(function (val, i) { return val === null || v.options[i] === val; });
      })[0];
    }
    function render() {
      var variant = selected();
      if (!variant) {
        if (submit) { submit.disabled = true; submit.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? (submit.getAttribute('data-label') || 'Add to cart') : 'Sold out';
      }
    }
    root.addEventListener('change', render);
    render();
  });

  /* ---- countdown ---- */
  document.querySelectorAll('[data-countdown]').forEach(function (root) {
    var target = new Date(root.getAttribute('data-countdown')).getTime();
    if (isNaN(target)) return;
    var wrap = root.parentNode;
    var cells = {
      days: root.querySelector('[data-cd-days]'),
      hours: root.querySelector('[data-cd-hours]'),
      minutes: root.querySelector('[data-cd-minutes]'),
      seconds: root.querySelector('[data-cd-seconds]')
    };
    var localEl = wrap.querySelector('[data-cd-local]');
    var liveEl = wrap.querySelector('[data-cd-live]');
    var timer = null;
    function pad(n) { return ('0' + n).slice(-2); }

    /* Show the drop moment in the visitor's own time zone. */
    if (localEl) {
      try {
        localEl.textContent = 'DROPS ' + new Date(target).toLocaleString(undefined, {
          weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short'
        }).toUpperCase() + ' // YOUR TIME';
      } catch (e) { /* older browsers: leave blank */ }
    }

    /* When the store is unlocked, send visitors in. Random delay so everyone doesn't hit at once. */
    function poll() {
      fetch('/', { cache: 'no-store', credentials: 'same-origin' })
        .then(function (r) { if (r.url && r.url.indexOf('/password') === -1) window.location.href = '/'; })
        .catch(function () {})
        .then(function () { setTimeout(poll, 10000 + Math.random() * 10000); });
    }

    function done() {
      clearInterval(timer);
      root.classList.add('is-live');
      if (liveEl) liveEl.hidden = false;
      if (document.body.classList.contains('template-password')) poll();
    }

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        Object.keys(cells).forEach(function (k) { if (cells[k]) cells[k].textContent = '00'; });
        done();
        return;
      }
      var s = Math.floor(diff / 1000);
      if (cells.days) cells.days.textContent = pad(Math.floor(s / 86400));
      if (cells.hours) cells.hours.textContent = pad(Math.floor(s / 3600) % 24);
      if (cells.minutes) cells.minutes.textContent = pad(Math.floor(s / 60) % 60);
      if (cells.seconds) cells.seconds.textContent = pad(s % 60);
    }
    timer = setInterval(tick, 1000);
    tick();
  });

  /* ---- cart quantity auto-submit ---- */
  document.querySelectorAll('[data-cart-form] input[name="updates[]"]').forEach(function (input) {
    input.addEventListener('change', function () { input.closest('form').submit(); });
  });
})();
